import PropTypes from 'prop-types';

import { ListRow, WithActions } from 'basic-components';

import Actions from './Actions';

const getTasksString = pipeline => [...new Set(pipeline.taskAndVersions.map(t => t.readableName))].join(", ")

const ActionsRow = ({ items }) => (
  items.map((item, index) => (
    <WithActions
        actions={
          <Actions
              index={index}
              items={items}
          />
        }
        key={index}
    >
      <ListRow>
        <div className="ng-inspector__list-content__row ng-inspector__list-content__name">
          {item.name}
        </div>
        <div className="ng-inspector__list-content__row ng-inspector__list-content__version">
          {item.version}
        </div>
        <div className="ng-inspector__list-content__row ng-inspector__list-content__group">
          {item.group}
        </div>
        <div className="ng-inspector__list-content__row ng-inspector__list-content__tasks">
          {getTasksString(item)}
        </div>
      </ListRow>
    </WithActions>
  ))
)

ActionsRow.propTypes = {
  items: PropTypes.array.isRequired
}

export default ActionsRow